import { FormConfig } from '@frontend/design-system';
import { textareaField } from '../../../utils/field-config-helpers';

export type MissedCallsFieldTypes = typeof missedCallsFields;

export const missedCallsFields = {
  introMessage: textareaField({
    required: true,
  }),
} satisfies FormConfig;
